import React from 'react';
import { Crown, CreditCard } from 'lucide-react';

export const PremiumTrialMessage = () => {
  return (
    <div className="bg-gradient-to-r from-emerald-900/30 to-blue-900/30 border border-emerald-500/50 rounded-lg p-3 mt-2 shadow-lg">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center">
          <div className="bg-emerald-500/20 p-1 rounded-full mr-2">
            <Crown className="h-4 w-4 text-emerald-400" />
          </div>
          <h3 className="text-emerald-300 text-sm font-bold">Premium Trial + Free Forever</h3>
        </div>
        <div className="bg-emerald-500/20 px-2 py-1 rounded-full">
          <span className="text-xs text-emerald-300 font-bold">NO RISK</span>
        </div>
      </div>
      
      <div className="border-t border-emerald-500/30 pt-2">
        <p className="text-xs text-gray-400 flex items-center justify-center">
          <CreditCard className="h-3 w-3 text-emerald-400 mr-1" />
          <span className="font-medium">No payment • 7 days premium • Then free forever</span>
        </p>
      </div>
    </div>
  );
};

export default PremiumTrialMessage;
